module.exports = __webpack_public_path__ + "img/association_member.f14d7f04.svg";